// Copyright (c) 2023 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

export default `time,event_lat,event_lng,icon,icon-bk,annotation-severity,annotation-html
2016-06-28 20:02:06,37.778564,-122.39096,accel,accel,3,"Braking at 10:32pm, -0.3g"
2016-06-28 20:09:18,37.78824,-122.40894,add-person,add-person,3,"10:33pm,37.3490528616667,-121.972682895794,accel,3,""Acceleration at 10:33pm, +0.2g"""
2016-06-28 20:03:16,38.281445,-122.29453,alert,alert,6,"Aborted lane change, 10:34pm"
2016-06-28 20:05:55,37.79354,-122.40121,android,android,5,Period of dangerous driving 10:32pm-10:34pm
2016-06-28 20:03:39,37.456535,-122.136795,apple,apple,4,"Braking at 10:32pm, -0.3g"
2016-06-28 20:05:51,37.40066,-122.10239,attach,attach,3,"10:33pm,37.3490528616667,-121.972682895794,accel,3,""Acceleration at 10:33pm, +0.2g"""
2016-06-28 20:08:20,37.77118,-122.42459,bold,bold,3,"Aborted lane change, 10:34pm"
2016-06-28 20:05:16,37.879066,-122.26108,,bookmark,,Period of dangerous driving 10:32pm-10:34pm
2016-06-28 20:03:01,37.775578,-122.39363,,brake,3,"Braking at 10:32pm, -0.3g"
2016-06-28 20:03:22,37.7892,-122.408966,,briefcase,2,"10:33pm,37.3490528616667,-121.972682895794,accel,3,""Acceleration at 10:33pm, +0.2g"""
2016-06-28 20:04:42,37.779964,-122.40398,bug,bug,3,"Aborted lane change, 10:34pm"
2016-06-28 20:03:55,37.792385,-122.406494,,calculator,2,Period of dangerous driving 10:32pm-10:34pm
2016-06-28 20:08:31,37.791046,-122.401855,calendar,calendar,5,"Braking at 10:32pm, -0.3g"
2016-06-28 20:00:18,37.769897,-122.41168,,camera,2,"10:33pm,37.3490528616667,-121.972682895794,accel,3,""Acceleration at 10:33pm, +0.2g"""
2016-06-28 20:02:13,37.798237,-122.41889,,cancel,5,"Aborted lane change, 10:34pm"
2016-06-28 20:06:23,37.76018,-122.41097,,car-black,5,Period of dangerous driving 10:32pm-10:34pm
2016-06-28 20:05:16,37.37006,-121.96353,car-suv,car-suv,4,"Braking at 10:32pm, -0.3g"
2016-06-28 20:06:28,37.418655,-122.149734,car-taxi,car-taxi,3,"10:33pm,37.3490528616667,-121.972682895794,accel,3,""Acceleration at 10:33pm, +0.2g"""
2016-06-28 20:09:41,37.787052,-122.41089,,car-uberx,,"Aborted lane change, 10:34pm"
2016-06-28 20:08:20,37.780136,-122.40495,,car,4,Period of dangerous driving 10:32pm-10:34pm
2016-06-28 20:01:57,37.753033,-122.42929,,cart,4,"Braking at 10:32pm, -0.3g"
2016-06-28 20:01:29,37.749577,-122.41829,,certified,5,"10:33pm,37.3490528616667,-121.972682895794,accel,3,""Acceleration at 10:33pm, +0.2g"""
2016-06-28 20:10:00,37.786648,-122.401634,,chart-area,3,"Aborted lane change, 10:34pm"
2016-06-28 20:02:57,38.122818,-122.25759,,chart,,Period of dangerous driving 10:32pm-10:34pm
2016-06-28 20:07:48,37.788277,-122.40152,check-alt,check-alt,1,"Braking at 10:32pm, -0.3g"
2016-06-28 20:01:43,37.876453,-122.270096,,check,3,"10:33pm,37.3490528616667,-121.972682895794,accel,3,""Acceleration at 10:33pm, +0.2g"""
2016-06-28 20:09:28,37.61695,-122.38396,circle-check,circle-check,5,"Aborted lane change, 10:34pm"
2016-06-28 20:06:07,37.80718,-122.40902,,circle-ellipsis,5,Period of dangerous driving 10:32pm-10:34pm
2016-06-28 20:05:26,37.751713,-122.42713,circle,circle,3,"Braking at 10:32pm, -0.3g"
2016-06-28 20:08:57,37.75977,-122.41924,,clipboard,,"10:33pm,37.3490528616667,-121.972682895794,accel,3,""Acceleration at 10:33pm, +0.2g"""
2016-06-28 20:08:14,37.80641,-122.404816,,clock,1,"Aborted lane change, 10:34pm"
2016-06-28 20:08:44,37.751354,-122.43317,,cloud,5,Period of dangerous driving 10:32pm-10:34pm
2016-06-28 20:02:46,37.40591,-121.943054,,code-alt,1,"Braking at 10:32pm, -0.3g"
2016-06-28 20:07:07,37.74202,-122.49926,,code,1,"10:33pm,37.3490528616667,-121.972682895794,accel,3,""Acceleration at 10:33pm, +0.2g"""
2016-06-28 20:03:39,37.80315,-122.402794,,control-off,5,"Aborted lane change, 10:34pm"
2016-06-28 20:04:01,37.44642,-122.16117,,control-on,4,Period of dangerous driving 10:32pm-10:34pm
2016-06-28 20:01:25,37.796837,-122.40023,,crosshairs-alt,5,"Braking at 10:32pm, -0.3g"
2016-06-28 20:08:14,38.2984,-122.28682,,crosshairs,4,"10:33pm,37.3490528616667,-121.972682895794,accel,3,""Acceleration at 10:33pm, +0.2g"""
2016-06-28 20:08:49,37.73762,-122.48069,,crown,2,"Aborted lane change, 10:34pm"
2016-06-28 20:08:21,37.444183,-122.170074,,dangerous,4,Period of dangerous driving 10:32pm-10:34pm
2016-06-28 20:06:49,37.77029,-122.44518,,dashboard,4,"Braking at 10:32pm, -0.3g"
2016-06-28 20:03:43,37.781548,-122.41132,delete-alt,delete-alt,,"10:33pm,37.3490528616667,-121.972682895794,accel,3,""Acceleration at 10:33pm, +0.2g"""
2016-06-28 20:09:47,37.770683,-122.403145,delete-thin,delete-thin,2,"Aborted lane change, 10:34pm"
2016-06-28 20:04:15,37.780903,-122.40269,,delete,4,Period of dangerous driving 10:32pm-10:34pm
2016-06-28 20:05:04,37.368206,-121.92748,,details,2,"Braking at 10:32pm, -0.3g"
2016-06-28 20:02:47,37.890514,-122.057884,,directions,3,"10:33pm,37.3490528616667,-121.972682895794,accel,3,""Acceleration at 10:33pm, +0.2g"""
2016-06-28 20:03:07,37.765217,-122.40161,,down-arrow-alt,3,"Aborted lane change, 10:34pm"
2016-06-28 20:07:58,37.759308,-122.40985,,down-arrow-thin,3,Period of dangerous driving 10:32pm-10:34pm
2016-06-28 20:07:23,37.96648,-121.7171,,down-arrow,2,"Braking at 10:32pm, -0.3g"
2016-06-28 20:07:41,37.763405,-122.45817,,download,4,"10:33pm,37.3490528616667,-121.972682895794,accel,3,""Acceleration at 10:33pm, +0.2g"""
2016-06-28 20:01:55,37.777637,-122.42391,,draw-shape,3,"Aborted lane change, 10:34pm"
2016-06-28 20:08:19,37.789856,-122.39953,,duplicate,1,Period of dangerous driving 10:32pm-10:34pm
2016-06-28 20:08:29,37.557186,-121.9803,,edit,4,"Braking at 10:32pm, -0.3g"
2016-06-28 20:06:47,37.78949,-122.45104,,employees,4,"10:33pm,37.3490528616667,-121.972682895794,accel,3,""Acceleration at 10:33pm, +0.2g"""
2016-06-28 20:07:11,37.795612,-122.394196,,enclosed-up-arrow,5,"Aborted lane change, 10:34pm"
2016-06-28 20:03:58,38.30026,-122.30107,,eta,5,Period of dangerous driving 10:32pm-10:34pm
2016-06-28 20:02:03,37.78702,-122.433464,,events,4,"Braking at 10:32pm, -0.3g"
2016-06-28 20:06:50,37.800163,-122.46132,,eye-closed,5,"10:33pm,37.3490528616667,-121.972682895794,accel,3,""Acceleration at 10:33pm, +0.2g"""
2016-06-28 20:07:22,37.800583,-122.44561,,eye,2,"Aborted lane change, 10:34pm"
2016-06-28 20:06:02,37.29343,-121.873825,,facebook,,Period of dangerous driving 10:32pm-10:34pm
2016-06-28 20:04:19,37.792248,-122.400986,,fare-split,,"Braking at 10:32pm, -0.3g"
2016-06-28 20:02:50,37.762466,-122.46835,,files,3,"10:33pm,37.3490528616667,-121.972682895794,accel,3,""Acceleration at 10:33pm, +0.2g"""
2016-06-28 20:09:41,37.913967,-122.04143,,film,5,"Aborted lane change, 10:34pm"
2016-06-28 20:02:38,37.70338,-122.474976,,filter,4,Period of dangerous driving 10:32pm-10:34pm
2016-06-28 20:01:50,37.698505,-121.930046,,free-rides,,"Braking at 10:32pm, -0.3g"
2016-06-28 20:05:42,37.785946,-122.39721,,fullscreen-exit,3,"10:33pm,37.3490528616667,-121.972682895794,accel,3,""Acceleration at 10:33pm, +0.2g"""
2016-06-28 20:09:09,37.80069,-122.437805,,fullscreen,2,"Aborted lane change, 10:34pm"
2016-06-28 20:06:49,37.79061,-122.420425,,geofence,4,Period of dangerous driving 10:32pm-10:34pm
2016-06-28 20:06:34,37.788998,-122.40528,,github,4,"Braking at 10:32pm, -0.3g"
2016-06-28 20:07:35,37.745995,-122.17901,,globe,1,"10:33pm,37.3490528616667,-121.972682895794,accel,3,""Acceleration at 10:33pm, +0.2g"""
2016-06-28 20:01:57,37.368294,-121.927605,,google+,5,"Aborted lane change, 10:34pm"
2016-06-28 20:02:35,37.39618,-121.87303,,graph,1,Period of dangerous driving 10:32pm-10:34pm
2016-06-28 20:05:54,37.370895,-121.99693,,heart-empty,4,"Braking at 10:32pm, -0.3g"
2016-06-28 20:00:23,37.868176,-122.291626,,heart,4,"10:33pm,37.3490528616667,-121.972682895794,accel,3,""Acceleration at 10:33pm, +0.2g"""
2016-06-28 20:07:25,37.78467,-122.46707,,help,3,"Aborted lane change, 10:34pm"
2016-06-28 20:08:47,37.39412,-122.080154,,hipchat,1,Period of dangerous driving 10:32pm-10:34pm
2016-06-28 20:09:58,37.42982,-122.146904,,home,5,"Braking at 10:32pm, -0.3g"
2016-06-28 20:05:32,37.720642,-122.476135,,icons,5,"10:33pm,37.3490528616667,-121.972682895794,accel,3,""Acceleration at 10:33pm, +0.2g"""
2016-06-28 20:00:05,37.77196,-122.288506,,id-card,2,"Aborted lane change, 10:34pm"
2016-06-28 20:04:07,37.801647,-122.41509,,info,4,Period of dangerous driving 10:32pm-10:34pm
2016-06-28 20:04:53,37.557343,-121.97734,,instagram,2,"Braking at 10:32pm, -0.3g"
2016-06-28 20:09:37,37.79315,-122.394844,,italic,3,"10:33pm,37.3490528616667,-121.972682895794,accel,3,""Acceleration at 10:33pm, +0.2g"""
2016-06-28 20:03:50,37.763123,-122.408714,,key,2,"Aborted lane change, 10:34pm"
2016-06-28 20:00:16,37.80429,-122.41334,,layers,4,Period of dangerous driving 10:32pm-10:34pm
2016-06-28 20:06:53,37.737015,-122.21498,,layout,5,"Braking at 10:32pm, -0.3g"
2016-06-28 20:01:35,37.688007,-122.13062,,left-arrow-alt,,"10:33pm,37.3490528616667,-121.972682895794,accel,3,""Acceleration at 10:33pm, +0.2g"""
2016-06-28 20:06:56,36.60167,-121.89041,,left-arrow-thin,2,"Aborted lane change, 10:34pm"
2016-06-28 20:00:33,37.77245,-122.5089,,left-arrow,3,Period of dangerous driving 10:32pm-10:34pm
2016-06-28 20:01:32,37.787792,-122.39695,,link,5,"Braking at 10:32pm, -0.3g"
2016-06-28 20:08:15,37.789505,-122.39494,,linkedin,4,"10:33pm,37.3490528616667,-121.972682895794,accel,3,""Acceleration at 10:33pm, +0.2g"""
2016-06-28 20:07:34,37.789154,-122.43993,,location,2,"Aborted lane change, 10:34pm"
2016-06-28 20:00:32,37.38603,-121.972755,,lock,5,Period of dangerous driving 10:32pm-10:34pm
2016-06-28 20:08:30,37.776512,-122.42585,,lost,,"Braking at 10:32pm, -0.3g"
2016-06-28 20:05:31,37.764816,-122.413124,,mail-open,,"10:33pm,37.3490528616667,-121.972682895794,accel,3,""Acceleration at 10:33pm, +0.2g"""
2016-06-28 20:03:24,37.80028,-122.40916,,mail-sent,2,"Aborted lane change, 10:34pm"
2016-06-28 20:01:29,37.927547,-122.05777,,mail,,Period of dangerous driving 10:32pm-10:34pm
2016-06-28 20:04:58,37.37899,-122.11877,,menu,,"Braking at 10:32pm, -0.3g"
2016-06-28 20:02:13,37.78388,-122.40356,,message-phone,1,"10:33pm,37.3490528616667,-121.972682895794,accel,3,""Acceleration at 10:33pm, +0.2g"""
2016-06-28 20:07:08,37.41093,-121.94651,,messages,,"Aborted lane change, 10:34pm"
2016-06-28 20:04:38,37.776924,-122.422935,,minus-alt,1,Period of dangerous driving 10:32pm-10:34pm
2016-06-28 20:08:29,37.80069,-122.40894,,minus,4,"Braking at 10:32pm, -0.3g"
2016-06-28 20:06:47,37.79061,-122.29453,,moon,4,"10:33pm,37.3490528616667,-121.972682895794,accel,3,""Acceleration at 10:33pm, +0.2g"""
2016-06-28 20:07:11,37.788998,-122.40121,,note,5,"Aborted lane change, 10:34pm"
2016-06-28 20:03:58,37.745995,-122.136795,,notification,5,Period of dangerous driving 10:32pm-10:34pm
2016-06-28 20:02:03,37.368294,-122.10239,,notifications-mute,4,"Braking at 10:32pm, -0.3g"
2016-06-28 20:06:50,37.39618,-122.42459,,pause,5,"10:33pm,37.3490528616667,-121.972682895794,accel,3,""Acceleration at 10:33pm, +0.2g"""
2016-06-28 20:07:22,37.370895,-122.26108,,payment,2,"Aborted lane change, 10:34pm"
2016-06-28 20:06:02,37.868176,-122.39363,,phone-alt,,Period of dangerous driving 10:32pm-10:34pm
2016-06-28 20:04:19,37.78467,-122.408966,,phone,,"Braking at 10:32pm, -0.3g"
2016-06-28 20:02:50,37.39412,-122.40398,,picture,3,"10:33pm,37.3490528616667,-121.972682895794,accel,3,""Acceleration at 10:33pm, +0.2g"""
2016-06-28 20:09:41,37.42982,-122.406494,,pin,5,"Aborted lane change, 10:34pm"
2016-06-28 20:02:38,37.720642,-122.401855,,place,4,Period of dangerous driving 10:32pm-10:34pm
2016-06-28 20:01:50,37.77196,-122.41168,,play,,"Braking at 10:32pm, -0.3g"
2016-06-28 20:05:42,37.801647,-122.41889,,plus-alt,3,"10:33pm,37.3490528616667,-121.972682895794,accel,3,""Acceleration at 10:33pm, +0.2g"""
2016-06-28 20:09:09,37.557343,-122.41097,,plus,2,"Aborted lane change, 10:34pm"
2016-06-28 20:06:49,37.79315,-121.96353,,power,4,Period of dangerous driving 10:32pm-10:34pm
2016-06-28 20:06:34,37.763123,-122.149734,,previous,4,"Braking at 10:32pm, -0.3g"
2016-06-28 20:07:35,37.80429,-122.41089,,printer,1,"10:33pm,37.3490528616667,-121.972682895794,accel,3,""Acceleration at 10:33pm, +0.2g"""
2016-06-28 20:01:57,37.737015,-122.40495,,profile,5,"Aborted lane change, 10:34pm"
2016-06-28 20:02:35,37.688007,-122.42929,,promo-alt,1,Period of dangerous driving 10:32pm-10:34pm
2016-06-28 20:05:54,36.60167,-122.41829,,promo,4,"Braking at 10:32pm, -0.3g"
2016-06-28 20:00:23,37.77245,-122.401634,,receipt,4,"10:33pm,37.3490528616667,-121.972682895794,accel,3,""Acceleration at 10:33pm, +0.2g"""
2016-06-28 20:07:25,37.787792,-122.25759,,reset,3,"Aborted lane change, 10:34pm"
2016-06-28 20:08:47,37.789505,-122.40152,,right-arrow-alt,1,Period of dangerous driving 10:32pm-10:34pm
2016-06-28 20:09:58,37.789154,-122.270096,,right-arrow-thin,5,"Braking at 10:32pm, -0.3g"
2016-06-28 20:05:32,37.38603,-122.38396,,right-arrow,5,"10:33pm,37.3490528616667,-121.972682895794,accel,3,""Acceleration at 10:33pm, +0.2g"""
2016-06-28 20:00:05,37.776512,-122.40902,,route-dot,2,"Aborted lane change, 10:34pm"
2016-06-28 20:04:07,37.764816,-122.42713,,search,4,Period of dangerous driving 10:32pm-10:34pm
2016-06-28 20:04:53,37.80028,-122.41924,,send,2,"Braking at 10:32pm, -0.3g"
2016-06-28 20:09:37,37.927547,-122.404816,,settings-alt,3,"10:33pm,37.3490528616667,-121.972682895794,accel,3,""Acceleration at 10:33pm, +0.2g"""
2016-06-28 20:03:50,37.37899,-122.43317,,settings,2,"Aborted lane change, 10:34pm"
2016-06-28 20:00:16,37.78388,-121.943054,,share-alt,4,Period of dangerous driving 10:32pm-10:34pm
2016-06-28 20:06:53,37.41093,-122.49926,,share,5,"Braking at 10:32pm, -0.3g"
2016-06-28 20:01:35,37.776924,-122.402794,,sketch,,"10:33pm,37.3490528616667,-121.972682895794,accel,3,""Acceleration at 10:33pm, +0.2g"""
2016-06-28 20:06:56,37.80069,-122.16117,,skip,2,"Aborted lane change, 10:34pm"
2016-06-28 20:00:33,37.79061,-122.40023,,slanted-down-arrow,3,Period of dangerous driving 10:32pm-10:34pm
2016-06-28 20:01:32,37.788998,-122.28682,,slanted-up-arrow,5,"Braking at 10:32pm, -0.3g"
2016-06-28 20:08:15,37.745995,-122.48069,,sound-off,4,"10:33pm,37.3490528616667,-121.972682895794,accel,3,""Acceleration at 10:33pm, +0.2g"""
2016-06-28 20:07:34,37.368294,-122.170074,,sound-on,2,"Aborted lane change, 10:34pm"
2016-06-28 20:00:32,37.39618,-122.44518,,star,5,Period of dangerous driving 10:32pm-10:34pm
2016-06-28 20:08:30,37.370895,-122.41132,,steering-wheel,,"Braking at 10:32pm, -0.3g"
2016-06-28 20:05:31,37.868176,-122.403145,,stopwatch,,"10:33pm,37.3490528616667,-121.972682895794,accel,3,""Acceleration at 10:33pm, +0.2g"""
2016-06-28 20:03:24,37.78467,-122.40269,,sun,2,"Aborted lane change, 10:34pm"
2016-06-28 20:01:29,37.39412,-121.92748,,support,,Period of dangerous driving 10:32pm-10:34pm
2016-06-28 20:04:58,37.42982,-122.057884,,surge,,"Braking at 10:32pm, -0.3g"
2016-06-28 20:02:13,37.720642,-122.40161,,swerve,1,"10:33pm,37.3490528616667,-121.972682895794,accel,3,""Acceleration at 10:33pm, +0.2g"""
2016-06-28 20:07:08,37.77196,-122.40985,,thumbs-up,,"Aborted lane change, 10:34pm"
2016-06-28 20:04:38,37.801647,-121.7171,,trash,1,Period of dangerous driving 10:32pm-10:34pm
2016-06-28 20:06:53,37.557343,-122.45817,,trip-history,5,"10:33pm,37.3490528616667,-121.972682895794,accel,3,""Acceleration at 10:33pm, +0.2g"""
2016-06-28 20:01:35,37.79315,-122.42391,,trips,2,"Aborted lane change, 10:34pm"
2016-06-28 20:06:56,37.763123,-122.39953,,trophy,4,Period of dangerous driving 10:32pm-10:34pm
2016-06-28 20:00:33,37.80429,-121.9803,,twitter,2,"Braking at 10:32pm, -0.3g"
2016-06-28 20:01:32,37.737015,-122.45104,,uber-u,3,"10:33pm,37.3490528616667,-121.972682895794,accel,3,""Acceleration at 10:33pm, +0.2g"""
2016-06-28 20:08:15,37.688007,-122.394196,,uber,2,"Aborted lane change, 10:34pm"
2016-06-28 20:07:34,36.60167,-122.30107,,underline,4,Period of dangerous driving 10:32pm-10:34pm
2016-06-28 20:00:32,37.77245,-122.433464,,unlock,5,"Braking at 10:32pm, -0.3g"
2016-06-28 20:08:30,37.787792,-122.46132,,unstar,,"10:33pm,37.3490528616667,-121.972682895794,accel,3,""Acceleration at 10:33pm, +0.2g"""
2016-06-28 20:05:31,37.789505,-122.44561,,up-arrow-alt,2,"Aborted lane change, 10:34pm"
2016-06-28 20:03:24,37.789154,-121.873825,,up-arrow-thin,3,Period of dangerous driving 10:32pm-10:34pm
2016-06-28 20:01:29,37.38603,-122.400986,,up-arrow,5,"Braking at 10:32pm, -0.3g"
2016-06-28 20:04:58,37.776512,-122.46835,,upload,4,"10:33pm,37.3490528616667,-121.972682895794,accel,3,""Acceleration at 10:33pm, +0.2g"""
2016-06-28 20:02:13,37.764816,-122.04143,,wrench,2,"Aborted lane change, 10:34pm"`;

export const config = {
  version: 'v1',
  config: {
    visState: {
      filters: [],
      layers: [
        {
          id: 'xbbp4of',
          type: 'hexagon',
          config: {
            dataId: 'test_icon_data',
            label: 'new layer',
            color: [221, 178, 124],
            columns: {
              lat: 'event_lat',
              lng: 'event_lng'
            },
            isVisible: true,
            visConfig: {
              opacity: 0.8,
              worldUnitSize: 0.5,
              resolution: 8,
              colorRange: {
                name: 'Global Warming',
                type: 'sequential',
                category: 'Uber',
                colors: ['#5A1846', '#900C3F', '#C70039', '#E3611C', '#F1920E', '#FFC300']
              },
              coverage: 1,
              sizeRange: [0, 500],
              percentile: [0, 100],
              elevationPercentile: [0, 100],
              elevationScale: 5,
              'hi-precision': false,
              colorAggregation: 'average',
              sizeAggregation: 'average',
              enable3d: true
            }
          },
          visualChannels: {
            colorField: {
              name: 'annotation-severity',
              type: 'integer'
            },
            colorScale: 'quantile',
            sizeField: null,
            sizeScale: 'linear'
          }
        }
      ],
      interactionConfig: {
        tooltip: {
          fieldsToShow: {
            test_icon_data: ['time', 'icon', 'icon-bk', 'annotation-severity', 'annotation-html'],
            '6b69fg6ca': ['OBJECTID', 'ZIP_CODE', 'ID']
          },
          enabled: true
        },
        brush: {
          size: 0.5,
          enabled: false
        },
        geocoder: {
          enabled: false
        }
      },
      layerBlending: 'normal',
      splitMaps: []
    },
    mapState: {
      bearing: 24,
      dragRotate: true,
      latitude: 37.77189215118738,
      longitude: -122.42436896812978,
      pitch: 50,
      zoom: 12.132280694715416,
      isSplit: false
    },
    mapStyle: {
      styleType: 'dark',
      topLayerGroups: {
        label: true
      },
      visibleLayerGroups: {
        label: true,
        road: true,
        border: false,
        building: true,
        water: true,
        land: true
      }
    }
  }
};
